import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-addchild",
  "use": "icon-addchild-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-addchild\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>icon24/addchild</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-addchild_icon24-symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-addchild_icon24/addchild\" fill=\"#000000\">\n            <path d=\"M13,22 L13,12 L23,12 L23,22 L13,22 Z M19,16 L19,13 L17,13 L17,16 L14,16 L14,18 L17,18 L17,21 L19,21 L19,18 L22,18 L22,16 L19,16 Z\" id=\"icon-addchild_Combined-Shape\" />\n            <polygon id=\"icon-addchild_Path\" points=\"6 17 13 17 13 19 4 19 4 12 6 12\" />\n            <path d=\"M1,12 L1,2 L11,2 L11,12 L1,12 Z M9,4 L3,4 L3,10 L9,10 L9,4 Z\" id=\"icon-addchild_Shape\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/addchild.svg
// module id = 0/3N
// module chunks = 54